import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import { parseLinkNode } from "../../../utils/links";

const LinkWrapper = ({
    currentLanguageCode,
    linkNode,
    linkClass,
    linkStyle,
    children,
    renderChildren = false,
    fallbackWrapperEl: FallbackWrapperEl = null,
}) => {
    const link = parseLinkNode(linkNode, currentLanguageCode);

    if (!link.hasLink && renderChildren)
        return FallbackWrapperEl ? <FallbackWrapperEl className={linkClass}>{children}</FallbackWrapperEl> : children;

    switch (link.type) {
        case "external":
            return (
                <a href={link.value} className={linkClass} style={linkStyle} target="_blank" rel="noopener noreferrer">
                    {children}
                </a>
            );

        case "website":
        case "artificial":
        case "ecommerce-categories":
        case "ecommerce-products":
            return (
                <Link to={link.value} className={linkClass} style={linkStyle}>
                    {children}
                </Link>
            );
    }
};

export default connect()(multilanguage(LinkWrapper));
